import dhtmlXTreeView from './dhtmlXTreeView';
//dhtmlXTreeView的扩展
import {AssertUtils} from "goingutils";

dhtmlXTreeView.prototype.openAllNode = function (data) {
    let myTreeView = this;
    data.forEach(function (item) {
        if (AssertUtils.isArray(item.items)) {
            myTreeView.openItem(item["id"]);
            myTreeView.openAllNode(item.items);
        }
    });
};

dhtmlXTreeView.prototype.scrollToSelItem = function () {
    var mainContainer = $(`#${this.containerId} .dhxtreeview_cont`);
    var scrollToContainer = $(
        `#${this.containerId} .dhxtreeview_item_text_selected`
    );
    mainContainer.animate(
        {
            scrollTop:
                scrollToContainer.offset().top -
                mainContainer.offset().top +
                mainContainer.scrollTop() -
                30
        },
        100
    );
};
/**
 * 清空控件的容器信息
 * @param inputId
 */
dhtmlXTreeView.prototype.unloadAll = function (inputId) {
    $(`#${inputId}_tree_drop`)
        .parent()
        .parent()
        .remove();
};

//查找节点
dhtmlXTreeView.prototype.findItem = function (val) {
    var treeObj = this;
    if (!AssertUtils.isNotEmpty(val)) {
        return void 0;
    }
    //如果目前输入值是缓存中的值 则从数组中取值
    if (val === this.curFindVal) {
        if (
            this.curFindAry.length > 0 &&
            ++this.curIndex < this.curFindAry.length
        ) {
            this.close = false;
            this.selectItem(this.curFindAry[this.curIndex]);
            this.scrollToSelItem();
            setTimeout(function () {
                treeObj.close = true;
            }, 10);
        } else if (this.curFindAry.length > 0) {
            this.curIndex = 0;
            this.close = false;
            this.selectItem(this.curFindAry[this.curIndex]);
            setTimeout(function () {
                treeObj.close = true;
            }, 10);
        }
    } else {
        let findRes = [];
        //    如果输入值不是缓存中的值 则进行查询过滤
        for (var c in this.items) {
            if (this.items[c].text.indexOf(val) >= 0) {
                findRes.push(c);
            }
        }
        if (findRes.length >= 0) {
            this.close = false;
            this.selectItem(findRes[0]);
            this.scrollToSelItem();
            setTimeout(function () {
                treeObj.close = true;
            }, 10);
            this.curFindVal = val;
            this.curFindAry = findRes;
            this.curIndex = 0;
        } else {
            return void 0;
        }
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeView/dhtmlXTreeViewExtend.js